<template lang="pug">
    .breadcrumb.custom
        .container
            ul.breadcrumb(v-if="lstBreadcrumb && lstBreadcrumb !== null")
                li 
                  router-link(:to="{ name: 'body'}") {{$t("home.title")}}
                li(v-for="(page, index) in lstBreadcrumb[0]")
                  router-link(:to="{ name: page.name}" v-if="page.name !== undefined && page.name && page.name.length") {{page.title}}
                  router-link(:to="{ path: page.path}" v-else-if="page.path !== undefined && page.path && page.path.length") {{page.title}}
                  a(v-else) {{page.title}}
</template>

<script>
    export default {
      props: {
        lstBreadcrumb: null
      },
      methods: {
      },
      apollo: {
      }
    }
</script>

<style lang="scss" scoped>
    .breadcrumb.custom{background: #F8F8F8;padding: 0; margin-bottom: 15px; border-radius: 0;
      ul.breadcrumb {padding: 10px 15px;list-style: none;background-color: transparent;margin-bottom: 0px;
        li{display: inline;
          a{color: #B4B4B4;}
        }
        li+li:before {padding: 5px;color: #B4B4B4;content: "/\00a0";}
      }
    }
    @media (max-width: 991px){
      .breadcrumb.custom{
        ul.breadcrumb{margin: 0; padding: 10px 0;}
      } 
    }
</style>



// WEBPACK FOOTER //
// index.vue?1e319045